import { useMemo } from 'react';
import { TabContainer } from '../../../../components/common/tab/TabContainer';
import { useGetDownloadAppModalHeight } from '../../../../hooks/modal/useGetDownloadAppModalHeight';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { infoCategorySlice, infoCategoryType } from '../../../../store/infoCategorySlice';

// 카테고리 버튼보다 상단 영역의 height 값
const UPPER_CATEGORY_BUTTON_HEIGHT = 203;

export const InfoListPageCategorySection = () => {
  const dispatch = useAppDispatch();
  const infoCategoryStates = useAppSelector((state) => state.infoCategory);
  const infoCategoryActions = infoCategorySlice.actions;

  const globalTooltipStates = useAppSelector((state) => state.globalTooltip);

  const scrollYStates = useAppSelector((state) => state.scrollY);

  const defaultSelectedTabIndex = useMemo<number>(() => {
    switch (infoCategoryStates.selectedCategory) {
      case 'ALL':
        return 0;
      case 'NEWS':
        return 1;
      case 'MAGAZINE':
        return 2;
      default:
        return 0;
    }
  }, [infoCategoryStates.selectedCategory]);

  const handleInfoCategoryTabClick = (infoCategoryName: infoCategoryType) => {
    dispatch(infoCategoryActions.setSelectedCategory(infoCategoryName));
    if (
      scrollYStates.infoListPageScrollY >
      UPPER_CATEGORY_BUTTON_HEIGHT + globalTooltipStates.downloadAppTooltipHeight
    ) {
      window.scrollTo({ top: UPPER_CATEGORY_BUTTON_HEIGHT, behavior: 'instant' });
    }
  };

  const downloadAppModalHeight = useGetDownloadAppModalHeight();

  return (
    <TabContainer
      style={{
        width: 'calc(100% - 32px)',
        transform: 'translateX(16px)',
        position: 'sticky',
        top: `${40 + downloadAppModalHeight}px`,
        zIndex: 50,
        backgroundColor: 'white',
      }}
      tabInfos={[
        {
          text: '전체',
          element: <></>,
          handleTabClick: () => handleInfoCategoryTabClick('ALL'),
        },
        {
          text: '뉴스',
          element: <></>,
          handleTabClick: () => handleInfoCategoryTabClick('NEWS'),
        },
        {
          text: '매거진',
          element: <></>,
          handleTabClick: () => handleInfoCategoryTabClick('MAGAZINE'),
        },
      ]}
      defaultSelectedTabIndex={defaultSelectedTabIndex}
    />
  );
};
